import callCmAPI from 'services/helpers/call-cm-api'
import { CustomerTypeaheadResultT, WebApi2Response } from 'types/global'

/**
 * Customer typeahead for the customer-group member picker.
 *
 * Calls `GET /customer?q=<text>` — the CMAPI ILIKEs both `name` and
 * `local_id` and caps results at 25. Returns `[]` for an empty/blank
 * query so callers can avoid the round-trip via React Query's
 * `enabled` flag.
 */
export const customerTypeahead = (
  q: string,
): Promise<WebApi2Response<CustomerTypeaheadResultT[]>> => {
  const trimmed = q.trim()
  if (trimmed.length === 0) {
    return Promise.resolve({ success: true, data: [] })
  }

  return callCmAPI(`/customer?q=${encodeURIComponent(trimmed)}`, {
    method: 'get',
  }).then(({ data }) => {
    return data
  })
}
